export default class Cliente {

    constructor(resource) {
        this._resource = resource('cliente_supo');
        this._resource_cnt = resource('contrato_supo');
    }

    getTodos() {
        return this._resource
            .get()
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });

    }

    get(rid) {
        return this._resource
            .get(
                {
                    rid: rid,
                }
            )
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getSemValor(ano) {
        return this._resource
            .get(
                {
                    ano: ano,
                    aux: ""
                }
            )
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    save(rdados) {
        return this._resource
            .save({}, rdados)
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    upConexao(rdados) {
        return this._resource
            .update({}, rdados)
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    delete(rid) {
        return this._resource
            .delete({ rid: rid })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getContrato(rid) {
        return this._resource_cnt
            .get(
                {
                    rid: rid,
                }
            )
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getContratoStatus(rcnpj, rid) {
        return this._resource_cnt
            .get(
                {
                    rCNPJ: rcnpj,
                    ridCli: rid
                }
            )
            .then(res => res.bodyText
                , err => {
                    throw new Error(err.statusText)
                });
    }

    getContratosATermninar(referencia, raux, raux2) {
        console.log("Entrou");
        return this._resource
            .get(
                {
                    referencia: referencia,
                    raux: raux,
                    raux2: raux2,
                    raux3: "1",
                    raux4: "1"
                })
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }


    AtivaProdutos(rCNPJ, rFantasia, rOperacao, rAtivo, rId) {
        return this._resource_cnt
            .get(
                {
                    rCNPJ: rCNPJ,
                    rFantasia: rFantasia,
                    rOperacao: rOperacao,
                    rAtivo: rAtivo, 
                    rId: rId
                }
            )
            .then(res => res
                , err => {
                    throw new Error(err.statusText)
                });
    }
}